import CompanyFeatures from '~/components/page-home/company-features.vue'
import CompanyUsps from '~/components/page-home/company-usps.vue'
import FaqList from '~/components/public/faq/faq-list.vue'
import PublicHero from '~/components/public/public-hero.vue'
import RichTextSection from '~/components/public/rich-text-section.vue'
import SectionWithImage from '~/components/public/section-with-image.vue'
import FeaturedGroup from '~/components/public/featured/featured-group.vue'
import wTextWithCta from '../global/w-text-with-cta/w-text-with-cta.vue'


export default {
  __name: 'seo-page',
  props: {
  hero: {
    type: Object,
    required: true,
  },
  content: {
    type: Array,
    required: true,
  },
},
  setup(__props) {



const COMPONENT_MAPPING = {
  section_usp: CompanyUsps,
  faq_list: FaqList,
  section_text_with_image: SectionWithImage,
  section_feature: CompanyFeatures,
  section_read_more: FeaturedGroup,
  section_rich_text: RichTextSection,
  section_text_with_cta: wTextWithCta,
}

function getComponentKey(modelApiKey) {
  return COMPONENT_MAPPING[modelApiKey.toLowerCase()]
}

function getData(item) {
  switch (item.modelApiKey) {
    case 'section_usp':
      return {
        ...item,
        items: item.usp,
        button: item.button[0],
      }
    case 'section_rich_text':
      return {
        data: {
          ...item.richText,
        },
      }
    case 'section_read_more':
      return { items: item.links }
    case 'section_feature':
      return {
        items: item.features,
        title: item.title,
      }
    default:
      return item
  }
}

return { __sfc: true,COMPONENT_MAPPING, getComponentKey, getData, PublicHero }
}

}